/**
 * The console's sans stack (`fonts.stackSans` in the console's theme `_config.ts`), which its pages take from the body.
 * The library cannot import the console's copy, so a test in the console pins the two together:
 * `personas/broker/typeface.agreement.test.ts`.
 *
 * Mantine's own default is the system stack, which is what a Title or a text box falls back to when the theme names no
 * face. The dashboard names this one, so its Titles, inputs and buttons read in the same face as the Concierge page.
 */
export const CONSOLE_FONT_STACK =
  '"Roboto", Helvetica, Arial, "Arial Unicode", "Lucida Sans Unicode", sans-serif';
